<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import { save, refresh, trash } from 'ionicons/icons/index.mjs';
	import { generateID, flatten, fetchData } from '../shared/utils/Data.svelte'
	import { Form, components } from "../shared/form";
	const dispatch = createEventDispatcher();
	export let session;
	export let form;
	export let tooltips;
	let schema = null;
	let name = "";
	let ui = null;
	let value = null;
	let data = "";
	onMount(() => {
		console.log(form);
		if (form) {
			if (form.destination)
				return;
		   	if (form.schema)
				schema = form.schema;
			if (form.ui)
				ui = form.ui;
			if (form.name)
				name = form.name;
		}
	});
	function sendMessage(message) {
		dispatch('message', message);
	}
	async function saveReport(data, position) {
		var properties = flatten(data);
		var metadata = {}; 
		var geometry = {};

		metadata.user = session.name;
		metadata.user_id = session.id;
		metadata.form = form.name;
		metadata.form_id = form.id;
		metadata.created = new Date().toISOString();
		metadata.id = generateID();
		metadata.version = generateID();
		metadata.action = "upsert";
		metadata.layers = form.layers;
		metadata.layer_types = form.layer_types;
		metadata.project = form.project;
		metadata.map = "0";
		metadata.map_id = "0";
		metadata.dynamic = "0";
		  
		if (position) {
			metadata.longitude = position.coords.longitude;
			metadata.latitude = position.coords.latitude;
		}
		else {
			metadata.longitude = 0;
			metadata.latitude = 0;
		}

		geometry.type = "Point";
		geometry.coordinates = [metadata.longitude, metadata.latitude];
		metadata.feature = "New Feature";
		metadata.feature = metadata.feature + "";
		metadata.longitude = metadata.longitude + "";
		metadata.latitude = metadata.latitude + "";

		var meta = {};
		if (form.schema.metadata) {
			Object.keys(form.schema.metadata).map(function(key) {
					var value = schema.metadata[key];
					if (metadata[value])
						meta[key] = metadata[value];
				})
			}
		
		var feature = {
			type: "Feature",
			properties: properties,
			geometry: geometry,
			metadata: meta
		}

		let [res, err] = await fetchData("/v1/reports", {
			method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: JSON.stringify({
				metadata: metadata,
				feature: feature
			})
		});
		if (err) {
			console.log(err);
			dispatch('message', {
				type: "toast",
				data: {
					message: "Save error."
				}
			});
			return;
		}
		dispatch('message', {
			type: "toast",
			data: {
				message: "Form saved."
			}
		});
		dispatch('message', {
			type: "modal",
			modal: "confirmation"
		});
	}
	function saveHandler(data) {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (position) {
				saveReport(data, position)
			}, function (err) {
				saveReport(data)
			});
		}
		else {
			saveReport(data)
		}
	}
</script>

<div class="container grid-lg" in:fade>
	<div class="navbar">
		<div class="navbar-section">
            <div class="navbar-brand label label-primary">{form.name}</div>
        </div>
        <div class="navbar-section">
				<div class="btn-group">
				{#if !form.role || form.role >= 2}
            	<button type="submit" form="gsform" class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Save" on:click={(e) => {
                    e.currentTarget.blur();
				}}><i class="svg">{@html save.md}</i></button>
				{/if}
				<button type="button" class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Refresh" on:click|stopPropagation={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "content",
						data: {
							view: "form"
						}
					})
				}}><i class="svg">{@html refresh.md}</i></button>
        	</div>
		</div>
    </div>
	<div id="form-container">
    {#if schema}
        <div class="container pl-2 pr-2 mb-5" in:fade>
			<Form
				id="gsform"
				{schema}
				{ui}
				{components}
				{value}
				on:submit={e => {
					saveHandler(e.detail);
				}}
				on:reset={e => {
					console.log('reset', e);
				}}>
			</Form>
        </div>
    {/if}
	</div>
</div>

<style>
	#form-container {
		height: calc(100vh - 2.2rem);
		max-height: calc(100vh - 2.2rem);
		overflow-y: auto;
		background-color: white;
		padding-bottom: 5rem;
	}
    .navbar {
        position: sticky;
        top: 0;
        z-index: 99;
        background: #efefef;
        padding: 0.2rem 0.2rem 0.2rem 0.2rem;
    }
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
</style>